import styled from "styled-components";

export const MainSectionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  column-gap: 24px;
  .vision_d-flex {
    display: flex;
  }
  .vision_d-flex-1 {
    flex: 1;
  }
  .vision_flex-gap-12 {
    gap: 12px;
  }
`;

export const CheckboxListFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  .vision_config-checkbox-list-wrapper {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    flex-direction: column;
    max-height: ${(props) => props?.maxHeight || "auto"};
  }
  .vision_d-flex-1 {
    flex: 1;
  }
  .vision_text-capitalize {
    text-transform: capitalize;
  }
`;

export const ImageGalleryContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  padding: 8px 0;
`;

export const ThumbnailImage = styled.img`
  width: 82px;
  height: 81px;
  object-fit: cover;
  border-radius: 0px;
  border: 1px solid black;
`;

export const NoAppearancesMessage = styled.div`
  margin-bottom: 16px;
`;